import {Injectable} from '@angular/core';
import {IAssessmentRequestInfo} from './assessment-request-info.interface';

@Injectable()
export class AssignConsultantService {
  public assessmentRequestInfo: IAssessmentRequestInfo;
}
